<template>
    <div>
      <slot :data="cData" :loading="loading" :empty="empty" :total="total"></slot>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <!-- <div slot="spinner">Loading...</div> -->
        <error-message slot="no-more" :text="text"/>
        <error-message slot="no-results" :text="text2" />
      </infinite-loading>
    </div>
  </template>
    
  <script>
  import InfiniteLoading from "vue-infinite-loading";
  export default {
    name: "draft-scroll",
    data() {
      return {
        height: 0,
        page: 1,
        data: [],
        loading: 0,
        infiniteId: 1,
        btnFlag: false,
        total: 0
      };
    },
    //返回时要修改
    props: {
      text: {
        type: String,
        default: '主人，已经到底啦~'
      },
      text2: {
        type: String,
        default: '暂无草稿哦~'
      },
      limit: {
        type: Number,
        default: 10
      },
      url: {
        type: String,
        required: true
      },
      params: {
        type: Object,
        default() {
          return {};
        }
      },
      computeData: Function,
  
    },
    computed: {
      sendData() {
        return {
          ...this.params,
          page: this.page,
          limit: this.limit
        };
      },
      trigger() {
        return this.url + "?" + this.$QueryString.stringify(this.params);
      },
      cData() {
        return (
          (typeof this.computeData === "function"
            ? this.computeData(this.data)
            : this.data) || []
        );
      },
      empty() {
        return !this.cData.length;
      }
    },
    methods: {
      norepeat(arr) {
        for (var i = 0; i < arr.length - 1; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].id === undefined) continue;
            if (arr[i].id == arr[j].id) {
              arr.splice(j, 1);
              j--;
            }
          }
        }
        return arr;
      },
      infiniteHandler($state) {
        this.loading++;
        this.$Ajax(this.url, this.sendData)
          .then(rs => {
            this.total = rs.data.total
            this.page++;
            this.$emit("on-fetch", {
              data: rs.data.data,
              total: rs.data.total
            });
            if (
              rs.code == 200 &&
              rs.data.data instanceof Array &&
              rs.data.data.length > 0
            ) {
              this.data.push(...rs.data.data)
              this.data = this.norepeat(this.data)
              $state.loaded();
            }
            if (!rs.data.totalPage || rs.data.page >= rs.data.totalPage || rs.data.totalPage == 0) {
              $state.complete();
            }
          })
          .finally(() => {
            this.loading--;
          });
      },
      refresh() {
        this.page = 1;
        this.data = [];
        this.infiniteId++;
      }
  
    },
    watch: {
      // trigger: "refresh",
    },
    components: {
      InfiniteLoading
    }
  };
  </script>
    